const loadAccessoriesAction = {
  keep: 1, // Keep valid accessories and prices
  renew: 2, // Get new accessories matching those on quote with new prices
  overwrite: 3, // Remove all existing accessories and load standard accessories
}
export default loadAccessoriesAction
